import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController,ActionSheetController } from '@ionic/angular';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-idetail',
  templateUrl: './idetail.page.html',
  styleUrls: ['./idetail.page.scss'],
})

export class IdetailPage implements OnInit {

  data:any;
  user:any;
  url:any;
  offer:any;
  title:any;
  text:any;
  date_title:any;
  share_title:any;
  file_url:any;
  paid:any;
  q:any;

  constructor(public actionSheetController: ActionSheetController,private socialSharing: SocialSharing,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){


   this.user        = JSON.parse(localStorage.getItem(Constant.userData));
   this.data        = JSON.parse(localStorage.getItem(Constant.invoiceData));
   this.text        = JSON.parse(localStorage.getItem(Constant.appText));
   this.title       = this.data.invoice.type == 0 ? this.text.invoice_no : this.text.offer_no;
   this.date_title  = this.data.invoice.type == 0 ? this.text.invoice_date : this.text.offer_date;
   this.share_title = this.data.invoice.type == 0 ? this.text.share_invoice : this.text.share_offer;
   this.file_url    = this.data.url+"?lid="+localStorage.getItem(Constant.lid);
  }

  ngOnInit()
  {

  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }


  shareInvoice(id)
  {
    var title = this.data.invoice.type == 0 ? this.text.invoice_title : this.text.offer_title;

    this.socialSharing.share(this.text.view_invoice_here, title, null, this.url+"?id="+id);
  }

  async presentAlertConfirm(id) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.text.are_you_sure,
      message: this.text.delete_desc,
      mode:'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: this.text.yes,
          id: 'confirm-button',
          handler: () => {

          this.cancel(id);

          }
        }
      ]
    });

    await alert.present();
  }

  async cancel(id)
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.cancel(id).subscribe((response:any) => {

    this.presentToast(this.text.delete_success);

    this.nav.navigateBack('/list');

    loading.dismiss();

    });
  }

  async presentActionSheet(token) {
    const actionSheet = await this.actionSheetController.create({
      header: this.text.share_invoice,
      cssClass: 'my-custom-class',
      mode:'md',
      buttons: [{
        text: this.text.download_pdf,
        role: 'destructive',
        icon: 'download-outline',
        id: 'delete-button',
        data: {
          type: 'delete'
        },
        handler: () => {

          this.down(token);
        }
      }, {
        text: this.text.send_email,
        icon: 'mail-outline',
        data: 10,
        handler: () => {

          this.SendEmail();

        }
      }, {
        text: this.text.send_whatsapp,
        icon: 'logo-whatsapp',
        data: 'Data value',
        handler: () => {
          this.ShareWhatsapp();
        }
      }, {
        text: this.text.share_platform,
        icon: 'share-outline',
        handler: () => {

          this.shareAll();

        }
      }, {
        text: this.text.cancel,
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();

    const { role, data } = await actionSheet.onDidDismiss();
    console.log('onDidDismiss resolved with role and data', role, data);
  }

  down(token)
  {
    window.location.href = this.file_url+"&type=download";
  }

  ShareWhatsapp(){

    this.socialSharing.shareViaWhatsApp("Hi "+this.data.invoice.name+"\n\n "+this.text.download_title, "", this.file_url+"&type=download");

  }

   SendEmail()
   {
     if(this.data.invoice.email)
     {
        this.socialSharing.shareViaEmail("Hi "+this.data.invoice.name+"\n\n "+this.text.download_title+" "+this.file_url+"&type=download", 'Invoice '+this.data.invoice.invoice_no, [this.data.invoice.email]);
     }
     else
     {
       this.presentToast("There is no email assign with client");

       this.socialSharing.shareViaEmail("Hi "+this.data.invoice.name+"\n\n "+this.text.download_title+" "+this.file_url+"&type=download", 'Invoice '+this.data.invoice.invoice_no, []);
     }
   }

   shareAll()
   {
    this.socialSharing.share("Hi "+this.data.invoice.name+"\n\n "+this.text.download_title, '', null, this.file_url+"&type=download")
   }

   async showAlert(id) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.text.are_you_sure,
      message: this.text.mark_desc,
      mode:'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: this.text.yes,
          id: 'confirm-button',
          handler: () => {

          this.mark(id);

          }
        }
      ]
    });

    await alert.present();
  }

  async mark(id,type = 'mark')
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.mark(id,type).subscribe((response:any) => {

    this.presentToast(this.text.invoice_status);

    this.nav.navigateBack('/list');

    loading.dismiss();

    });
  }

  async presentAlertConfirmConvert(id) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.text.are_you_sure,
      message: this.text.convert_desc,
      mode:'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: this.text.yes,
          id: 'confirm-button',
          handler: () => {

          this.mark(id,'convert');

          }
        }
      ]
    });

    await alert.present();
  }
}
